module.exports = __webpack_public_path__ + "static/img/pic10.1.53e2292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic10.1.png
// module id = TeFs
// module chunks = 0